// Scroll reveal animation for GoSub Migration Campaign LP sections
const observerOptions = {
  threshold: 0.1,
  rootMargin: '0px 0px -50px 0px'
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('scroll-visible');
      observer.unobserve(entry.target);
    }
  });
}, observerOptions);

document.querySelectorAll('.gosub-migrate-lp-section .pain-point, .gosub-migrate-lp-section .solution-box, .gosub-migrate-lp-section .comparison-box, .gosub-migrate-lp-section .feature-card-dark, .gosub-migrate-lp-section .benefit-card, .gosub-migrate-lp-section .timeline-step').forEach(element => {
  observer.observe(element);
});
